import React from "react";
import styled from "styled-components";
import AudioPlayer from "../AudioPlayer";
import { Wrapper, InfoWrapper, Content, StyledImage } from "./style";
import { Loader } from "../../style/shared";
import { getOuterSpace } from "../../style/constants";

const Sub = styled.h1`
  ${getOuterSpace("padding")}
  position: absolute;
  font-size: 1.3rem;
  margin-bottom: 1rem;
  max-width: 28rem;
  inset: 0;
  margin-top: 10rem;
`;

const ProfileIntroSection = ({ content }) => (
  <Wrapper>
    <InfoWrapper>
      <Sub>
        Poems and myths set <br />
        into musical motion.
      </Sub>
      <AudioPlayer
        fixed={false}
        streamUrl={"/audio/ChildandWattleTree.m4a"}
        trackTitle={"'Child and Wattle Tree'"}
      />
      <Content>{content()}</Content>
    </InfoWrapper>
    <StyledImage
      src="/images/background/nau-back-01.jpg"
      alt="Background Image"
      loader={({ isLoaded }) => <Loader isLoaded={isLoaded} />}
      sources={[
        {
          srcset: [
            "/images/backgrsound/nau-back-01.jpg 1x",
            "/images/background/nau-back-01@2x.jpg 2x",
          ],
        },
      ]}
    />
  </Wrapper>
);

export default ProfileIntroSection;



// WEBPACK FOOTER //
// ./src/components/ProfileIntroSection/index.js